import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterRoad, MapAdapterBoundingBox } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_ROADSIDE } from "../../../../common/constants/appRoad"
import { RoadsideMobileContent } from "../../containers/RoadsideMobileContent"

export const RoadsideMobileRoutes = () => {

    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const roadworksMobileRoutes = useRoutes([
        {
            path: "/*",
            element:
                <>
                    <RoadsideMobileContent />
                    <MapAdapterBoundingBox module={API_MODULE_ROADSIDE} />
                    <SegmentSelectListener />
                </>,
        },
        {
            path: "/code/:code",
            element: <>
                <MapAdapterBoundingBox module={API_MODULE_ROADSIDE} />
                <RoadsideMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road",
            element:
                <>
                    <RoadsideMobileContent />
                    <MapAdapterRoad module={API_MODULE_ROADSIDE} />
                    <DetailSegmentSelectListener />
                </>,
        },
        {
            path: "/:road/code/:code",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad module={API_MODULE_ROADSIDE} />
                <RoadsideMobileContent />
            </>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ])

    return roadworksMobileRoutes
}